// Utile pour typer dans les apps front

// On a besoin de bidouiller avec les enums car : https://github.com/prisma/prisma/issues/12504#issuecomment-1147356141

import type {
  Address,
  Credit,
  Customer,
  CustomerSigner as CustomerSignerOrigin,
  Document,
  DocumentSignatureStatus as DocumentSignatureStatusOrigin,
  DocumentType as DocumentTypeOrigin,
  LogoType as LogoTypeOrigin,
  Notification,
  NotificationStatus as NotificationStatusOrigin,
  NotificationType as NotificationTypeOrigin,
  Payment,
  PaymentType as PaymentTypeOrigin,
  Project,
  ProjectType as ProjectTypeOrigin,
  Setting,
  SettingKey as SettingKeyOrigin,
  Shop,
  Supplier,
  SupplierCategory as SupplierCategoryOrigin,
  Supply,
  User,
  UserType as UserTypeOrigin,
  VATRate as VATRateOrigin,
} from '@prisma/client';

export type TechnicalPlanTable = PrismaJson.TechnicalPlanTable;
export type CSReportMeta = PrismaJson.CSReportMeta;
export type TechnicalPlanMeta = PrismaJson.TechnicalPlanMeta;
export type LetterSentTo = PrismaJson.LetterSentTo;

// Re-export non-enum types directly
export type {
  Address,
  Credit,
  Project,
  Shop,
  User,
  Document,
  Setting,
  Customer,
  Supply,
  Supplier,
  Payment,
  Notification,
};

// Guarantee that the implementation corresponds to the original enum types
export const UserType: { [k in UserTypeOrigin]: k } = {
  ADMIN: 'ADMIN',
  TECHNICIAN: 'TECHNICIAN',
  SELLER: 'SELLER',
  INSTALLER: 'INSTALLER',
} as const;

export const ProjectType: { [k in ProjectTypeOrigin]: k } = {
  KITCHEN: 'KITCHEN',
  COMPLEMENT: 'COMPLEMENT',
  AFTER_SALES: 'AFTER_SALES',
  ACCESSORY: 'ACCESSORY',
} as const;

export const DocumentType: { [k in DocumentTypeOrigin]: k } = {
  QUOTE: 'QUOTE',
  TECHNICAL_PLAN: 'TECHNICAL_PLAN',
  CONSTRUCTION_SITE_REPORT: 'CONSTRUCTION_SITE_REPORT',
  CONSTRUCTION_SITE_REVIEW: 'CONSTRUCTION_SITE_REVIEW',
  INITIAL_DEPOSIT_INVOICE: 'INITIAL_DEPOSIT_INVOICE',
  ON_DELIVERY_DEPOSIT_INVOICE: 'ON_DELIVERY_DEPOSIT_INVOICE',
  FINAL_INVOICE: 'FINAL_INVOICE',
  DELIVERY_ORDER: 'DELIVERY_ORDER',
  SERVICE_ORDER: 'SERVICE_ORDER',
} as const;

export const DocumentSignatureStatus: {
  [k in DocumentSignatureStatusOrigin]: k;
} = {
  DRAFT: 'DRAFT',
  ONGOING: 'ONGOING',
  DONE: 'DONE',
  DELETED: 'DELETED',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
  APPROVAL: 'APPROVAL',
  REJECTED: 'REJECTED',
  DECLINED: 'DECLINED',
} as const;

export const SettingKey: { [k in SettingKeyOrigin]: k } = {
  SUPPLIERS: 'SUPPLIERS',
  ITEM_NAMES: 'ITEM_NAMES',
  BULTHAUP_LINES: 'BULTHAUP_LINES',
  BULTHAUP_PROGRAMS: 'BULTHAUP_PROGRAMS',
  BULTHAUP_COLORS: 'BULTHAUP_COLORS',
  WORKTOP: 'WORKTOP',
  SPLASHBACK: 'SPLASHBACK',
  CUSTOMER_TITLES: 'CUSTOMER_TITLES',
} as const;

export const CustomerSigner: { [k in CustomerSignerOrigin]: k } = {
  CLIENT1: 'CLIENT1',
  CLIENT2: 'CLIENT2',
} as const;

export const PaymentType: { [k in PaymentTypeOrigin]: k } = {
  ON_ORDER: 'ON_ORDER',
  ON_DELIVERY: 'ON_DELIVERY',
  FINAL: 'FINAL',
} as const;

export const VATRate = {
  TWENTY_PERCENT: 'TWENTY_PERCENT',
  TEN_PERCENT: 'TEN_PERCENT',
  EIGHT_PERCENT: 'EIGHT_PERCENT',
  FOREIGN: 'FOREIGN',
} as const;

export const SupplierCategory: { [k in SupplierCategoryOrigin]: k } = {
  BULTHAUP: 'BULTHAUP',
  SANITARY: 'SANITARY',
  APPLIANCE: 'APPLIANCE',
  FURNITURE: 'FURNITURE',
  CARRIER: 'CARRIER',
  INSTALLER: 'INSTALLER',
  MEUBLE: 'MEUBLE',
  DECORATION: 'DECORATION',
  WORKS: 'WORKS',
} as const;

export const LogoType: { [k in LogoTypeOrigin]: k } = {
  BULTHAUP: 'BULTHAUP',
  FLORENCE: 'FLORENCE',
} as const;

export const NotificationStatus: { [k in NotificationStatusOrigin]: k } = {
  ACTIVE: 'ACTIVE',
  SEEN: 'SEEN',
  CLOSED: 'CLOSED',
} as const;

export const NotificationType: { [k in NotificationTypeOrigin]: k } = {
  QUOTE_SIGNED: 'QUOTE_SIGNED',
  TECHNICAL_PLAN_SIGNED: 'TECHNICAL_PLAN_SIGNED',
  DELIVERY_NOT_PAID: 'DELIVERY_NOT_PAID',
  INSTALLATION_PENDING: 'INSTALLATION_PENDING',
} as const;

// Re-export the original enum types
export type UserType = UserTypeOrigin;
export type ProjectType = ProjectTypeOrigin;
export type DocumentType = DocumentTypeOrigin;
export type DocumentSignatureStatus = DocumentSignatureStatusOrigin;
export type SettingKey = SettingKeyOrigin;
export type CustomerSigner = CustomerSignerOrigin;
export type PaymentType = PaymentTypeOrigin;
export type VATRate = VATRateOrigin;
export type SupplierCategory = SupplierCategoryOrigin;
export type NotificationStatus = NotificationStatusOrigin;
export type NotificationType = NotificationTypeOrigin;
